import { render, staticRenderFns } from "./OverlayError.vue?vue&type=template&id=18355181&"
import script from "./OverlayError.vue?vue&type=script&lang=js&"
export * from "./OverlayError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18355181')) {
      api.createRecord('18355181', component.options)
    } else {
      api.reload('18355181', component.options)
    }
    module.hot.accept("./OverlayError.vue?vue&type=template&id=18355181&", function () {
      api.rerender('18355181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayError.vue"
export default component.exports